export default "__VITE_ASSET__HQj0HabW__"